import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Standalone Route Guard (Functional Guard).
 * Prüft vor dem Routing, ob der Benutzer eingeloggt ist
 * und ob die Session noch gültig ist.
 */
export const canActivateGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  if (!authService.isLoggedIn()) {
    authService.logout()
  }
  return authService.checkSession().pipe(
    map((response) => {
      if (response.status !== 401 && response.statusText !== 'Unauthorized') {
        return true;
      } else {
        authService.logout();
        return false;
      }
    }),
    catchError(() => {
      authService.logout();
      return of(false);
    })
  );
};
